$( document ).ready(function() {

    let dotAnimate = $('.header-line__dot-item'),
        counterData;

    dotAnimate.each( (index, element) => {
        counterData = $(element).data("speed-animate");
        startAnimation(counterData, element)
    });

    function startAnimation(timeout, element) {
        setTimeout(function() {
            $(element).addClass('header-line__dot-item--animate')

        }, timeout);
    }
});
